import { render, staticRenderFns } from "./BioBreakActivityOnHold.vue?vue&type=template&id=5342cfa0&"
import script from "./BioBreakActivityOnHold.vue?vue&type=script&lang=js&"
export * from "./BioBreakActivityOnHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports